import axios from "../axios";
const END_POINT = "/cities";





const addCity = (cities) => axios.post(`${END_POINT}`, cities);
const getAllCities = (payload) => axios.get(`${END_POINT}?limit=${payload.limit}&page=${payload.page}`);
const getCity = (cityId) => axios.get(`${END_POINT}/${cityId}`);
const updateCity = (cityId, payload) => axios.patch(`${END_POINT}/${cityId}`, payload);
const searchCity = (payload) => axios.post(`${END_POINT}/search`, payload);
const deleteCity = (citiesId) => axios.delete(`${END_POINT}/${citiesId}`);


export {
  getAllCities,
  addCity,
  getCity,
  updateCity,
  searchCity,
  deleteCity
};
